import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a2cc6f14"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "setPassword"
};
const _hoisted_2 = {
  class: "head_title"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-band-phone-bigtitle"
}, "登陆或注册", -1));

const _hoisted_4 = {
  class: "user-changepwd-form"
};
const _hoisted_5 = {
  class: "user-form-item"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-form-key"
}, "账号/手机号", -1));

const _hoisted_7 = {
  class: "user-form-value"
};
const _hoisted_8 = {
  class: "user-form-item"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-form-key"
}, "账号密码", -1));

const _hoisted_10 = {
  class: "user-form-value"
};
const _hoisted_11 = {
  style: {
    "display": "flex"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"])]), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.params.username = $event),
    type: "text",
    placeholder: "账号/手机号"
  }, null, 512), [[_vModelText, $setup.params.username]])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.params.password = $event),
    type: "password",
    placeholder: "请输入密码"
  }, null, 512), [[_vModelText, $setup.params.password]])])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "user-public-btn",
    style: {
      "margin-top": "55px",
      "flex": "1 1 0%"
    },
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.login && $setup.login(...args))
  }, " 登录 ")])]);
}